import * as React from 'react';
import styled from 'styled-components';

import {BREAKPOINTS, COLORS, focusStyles, invertedFocusStyles} from '../../styles';
import {TextField} from '../../InputFields';
import {SystemIcons} from '../../icons';
import {IconButton} from '../../Button';
import {
  ComponentLStyling,
  ComponentTextStyle,
  ComponentXSStyling,
  ComponentXXSStyling
} from '../../styles';
import {InputFieldStyling} from '../../InputFields';

const NewsletterAndSocial = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  ${BREAKPOINTS.MEDIUM} {
    flex-direction: row;
  }
`;

const NewsletterEmailSection = styled.div`
  width: 100%;
  margin: 16px auto 0 auto;

  ${BREAKPOINTS.MEDIUM} {
    width: 60%;
    margin: 16px 0 0 0;
  }

  label {
    ${ComponentXXSStyling(ComponentTextStyle.Regular, COLORS.white)}
    margin-bottom: 2px;
  }
  div div {
    width: 100%;
    ${BREAKPOINTS.MEDIUM} {
      width: calc(100% - 82px);
      width: 288px;
    }
  }
  input {
    height: 48px;
  }
`;

const NewsletterEmail = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2px auto 0;

  ${BREAKPOINTS.MEDIUM} {
    margin: 2px 0 0 0;
    flex-direction: row;
  }

  ${InputFieldStyling} {
    &.focus-visible {
      ${invertedFocusStyles}
    }
  }
`;

const NewsletterButton = styled.button`
  background: transparent;
  width: 100%;
  height: 40px;
  border: 2px solid ${COLORS.white};
  box-sizing: border-box;
  border-radius: 8px;
  margin: 8px 0 4px 0;

  ${ComponentLStyling(ComponentTextStyle.Bold, COLORS.white)}

  ${BREAKPOINTS.MEDIUM} {
    width: 94px;
    margin: auto 0 4px 8px;
  }

  &:hover {
    cursor: pointer;
  }
  
  &:focus {
    ${invertedFocusStyles}
  }
`;

const SocialMedia = styled.div`
  color: ${COLORS.white};
  margin: 0 auto;

  button div {
    box-sizing: border-box;
    border-radius: 4px;
  }

  h4 {
    margin-top: 16px;
    margin-bottom: 8px;
    
    ${ComponentXSStyling(ComponentTextStyle.Regular, 'inherit')}
  }

  ${BREAKPOINTS.MEDIUM} {
    margin: 0 0 0 auto;
    button {
      margin: 0 0 0 12px;
    }
  }
`;

const SocialMediaButtons = styled.div`
  display: flex;
  justify-content: center;

  button div {
    display: flex;
    background-color: transparent;
    color: ${COLORS.white};
    margin: 0 0 0 20px;

    svg {
      fill: ${COLORS.white};
      path {
        fill: ${COLORS.white};
      }
    }

    &:first-child {
      margin: 0;
    }
    &:hover {
      background-color: ${COLORS.white};
      color: ${COLORS.neutral_600};
    }
    &:active {
      background-color: ${COLORS.primary_800};
      color: ${COLORS.primary_100};
    }
  }
  a {
    &:focus {
      ${invertedFocusStyles}
    }
  }

  ${BREAKPOINTS.MEDIUM} {
    justify-content: flex-end;
  }
`;

interface FooterNewsletterAndSocialSection {
  actionOnNewsletterSignup?: (email: string) => void;
  newsletterLabel: string;
  placeholderEmail?: string;
}

const FooterNewsletterAndSocialSection = ({ actionOnNewsletterSignup, newsletterLabel, placeholderEmail }: FooterNewsletterAndSocialSection) => {
  const [emailInput, setEmailInput] = React.useState<string>('');
  return (
    <NewsletterAndSocial>
      <NewsletterEmailSection>
        <label>{newsletterLabel}</label>
        <NewsletterEmail>
          <TextField id="NewsletterEmail" withoutBorder={true} placeholder={placeholderEmail} value={emailInput} onChange={(value: string) => setEmailInput(value)} />
          <NewsletterButton data-testid={'newsBtn'} onClick={(e: any) => actionOnNewsletterSignup && actionOnNewsletterSignup(e.target.value)}>Sign up</NewsletterButton>
        </NewsletterEmail>
      </NewsletterEmailSection>
      <SocialMedia>
        <h4>Follow us on social media</h4>
        <SocialMediaButtons>
          <a href="https://www.facebook.com/LaerdalMedical/" target="_blank" rel="noreferrer noopener">
            <IconButton variant="secondary" action={() => {}} tabIndex={-1}>
              <SystemIcons.Facebook />
            </IconButton>
          </a>
          <a href="https://twitter.com/laerdalmedical" target="_blank" rel="noreferrer noopener">
            <IconButton variant="secondary" action={() => {}} tabIndex={-1}>
              <SystemIcons.Twitter />
            </IconButton>
          </a>
          <a href="https://www.youtube.com/user/LaerdalMedical" target="_blank" rel="noreferrer noopener">
            <IconButton variant="secondary" action={() => {}} tabIndex={-1}>
              <SystemIcons.Youtube />
            </IconButton>
          </a>
        </SocialMediaButtons>
      </SocialMedia>
    </NewsletterAndSocial>
  );
};

export default FooterNewsletterAndSocialSection;
